import { isNotLast } from "@punks/core"
import React from "react"
import { lightestGray } from "../../../themes/variables"
import Stroke from "../../atoms/Stroke"
import { CustomCol, CustomRow } from "../../spacings"
import classes from "./RecapGrid.module.css"

export interface RecapGridItem {
  label: React.ReactNode
  content: React.ReactNode
  cta?: React.ReactNode
}

export interface RecapGridProps {
  items: RecapGridItem[]
}

const RecapGrid = ({ items }: RecapGridProps) => {
  return (
    <div className={classes.box}>
      {items.map((x, index) => (
        <React.Fragment key={index}>
          {/* <div className={classes.boxLine}>
            <div className={classes.boxLabel}>{x.label}</div>
            <div className={classes.boxContent}>{x.content}</div>
            {x.cta && <div className={classes.boxAction}>{x.cta}</div>}
          </div> */}
          <CustomRow alignItems="center" className={classes.boxLine}>
            <CustomCol xs={12} sm={3}>
              <div className={classes.boxLabel}>{x.label}</div>
            </CustomCol>
            <CustomCol xs={12} sm={7}>
              <div className={classes.boxContent}>{x.content}</div>
            </CustomCol>
            <CustomCol xs={0} sm={2}>
              {x.cta && <div className={classes.boxAction}>{x.cta}</div>}
            </CustomCol>
          </CustomRow>
          {isNotLast(index, items) && <Stroke colorValue={lightestGray} />}
        </React.Fragment>
      ))}
    </div>
  )
}

export default RecapGrid
